// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b59664cd","455":"5afb1f3b","977":"4f327213"}[chunkId] + ".chunk.js";
};